import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { StrongCustomerAuthenticationService } from '@paysafe/paysafe-wallet-saas-web/authentication';

import { environment } from '../environments/environment';
import { routes } from './app-routes.const';


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: StrongCustomerAuthenticationService,
      useFactory: () => StrongCustomerAuthenticationService.getInstance(),
    },
    provideAnimationsAsync(),
    provideTranslateService({
      lang: environment.DEFAULT_LANGUAGE ?? 'en-US',
      fallbackLang: environment.DEFAULT_LANGUAGE ?? 'en-US',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
    })
  ],
};
